const linuxDistros = [
    {
        "name": "Arch Linux",
        "discription": "Arch Linux is an independently developed, x86_64-optimised Linux distribution targeted at competent Linux users. It uses 'pacman', its home-grown package manager, to provide updates to the latest software applications with full dependency tracking. Operating on a rolling release system, Arch can be installed from a CD image or via an FTP server. The default install provides a solid base that enables users to create a custom installation. In addition, the Arch Build System (ABS) provides a way to easily build new packages, modify the configuration of stock packages, and share these packages with other users via the Arch Linux user repository. ",
        "features": [
            "independant",
            "server",
            "pacman",
            "goffice",
            "calligra",
            "libreoffice",
            "systemd"
        ]
    },
    {
        "name": "ArchBang Linux",
        "discription": "ArchBang Linux is a lightweight distribution based on Arch Linux. Using the i3 window manager, it is fast, up-to-date and suitable for both desktop and portable systems",
        "features": [
            "arch",
            "openbox",
            "live",
            "pacman",
            "systemd"
        ]
    },
    {
        "name": "BlackPanther OS",
        "discription": "BlackPanther OS is a Hungarian Linux distribution which borrows features from other major projects, including Mandriva Linux (graphical configuration tools), Fedora (graphical user interface) and Ubuntu (driver management). The distribution is designed for use at school, home and work as it contains applications for common daily tasks, such as time management, office work or media playback.",
        "features": [
            "independant",
            "kde plasma",
            "live",
            "easy set-up",
            "rpm"
        ]
    },
    {
        "name": "Calculate Linux",
        "discription": "Calculate Linux is a Gentoo-based family of three distinguished distributions. Calculate Directory Server (CDS) is a solution that supports Windows and Linux clients via LDAP + SAMBA, providing proxy, mail and Jabbers servers with streamlined user management. Calculate Linux Desktop (CLD) is a workstation and client distribution (with a choice of Cinnamon, KDE Plasma, LXQt, MATE or Xfce desktops) that includes a wizard to configure a connection to Calculate Directory Server. Calculate Linux Scratch (CLS) is a live CD with a build framework for creating a custom distribution.",
        "features": [
            "gentoo",
            "cinnamon",
            "kde plasma",
            "lxqt",
            "mate",
            "xfce",
            "live",
            "server",
            "source based",
            "easy set-up",
            "portage",
            "libreoffice",
            "openrc",
            "sysv",
            "multilingual"
        ]
    },
    {
        "name": "Canaima GNU/Linux",
        "discription": "Canaima GNU/Linux is a Venezuelan desktop distribution based on Debian GNU/Linux. It is primarily designed as a solution for the computers of National Public Administration in accordance with the presidential decree number 3.390 about the use of free technologies in National Public Administration in the country.",
        "features": [
            "debian",
            "gnome",
            "mate",
            "live",
            "easy set-up",
            "deb",
            "libreoffice",
            "systemd",
            "multilingual",
            "asian language support"
        ]
    },
    {
        "name": "CentOS",
        "discription": "CentOS as a group is a community of open source contributors and users which started in 2003 and has been sponsored by Red Hat since 2014. CentOS Linux versions up to CentOS Linux 8 are 100% compatible rebuilds of Red Hat Enterprise Linux, in full compliance with Red Hat's redistribution requirements. In 2020 it was announced CentOS Linux is being discontinued and replaced with CentOS Stream, a developer-focused distribution which acts as a middle-stream between Fedora and Red Hat Enterprise Linux. ",
        "features": [
            "red hat",
            "fedora",
            "gnome",
            "live",
            "server",
            "easy set-up",
            "flatpak",
            "rpm",
            "libreoffice",
            "systemd",
            "multilingual",
            "asian language support"
        ]
    },
    {
        "name": "Chakra GNU/Linux",
        "discription": "Chakra GNU/Linux is a user-friendly and powerful distribution and live CD originally forked from Arch Linux. It features a graphical installer, automatic hardware detection and configuration, the latest KDE desktop, and a variety of tools and extras.",
        "features": [
            "independant",
            "kde plasma",
            "live",
            "easy set-up",
            "pacman",
            "calligra",
            "systemd",
            "multilingual"
        ]
    },
    {
        "name": "CRUX",
        "discription": "CRUX is a lightweight, Linux distribution for computers running on 64-bit x86 processors. The distribution is targeted at experienced Linux users. The primary focus of this distribution is 'keep it simple', which is reflected in a simple tar.gz-based package system, BSD-style initscripts, and a relatively small collection of trimmed packages. The secondary focus is utilization of new Linux features and recent tools and libraries.",
        "features": [
            "independant",
            "openbox",
            "raspberry pi",
            "server",
            "source based",
            "tar.xz",
            "sysv"
        ]
    },
    {
        "name": "Debian",
        "discription": "The Debian Project is an association of individuals who have made common cause to create a free operating system. This operating system is called Debian. Debian systems currently use the Linux kernel. Linux is a completely free piece of software started by Linus Torvalds and supported by thousands of programmers worldwide. Of course, the thing that people want is application software: programs to help them get what they want to do done, from editing documents to running a business to playing games to writing more software. Debian comes with over 50,000 packages (precompiled software that is bundled up in a nice format for easy installation on your machine) - all of it free. It's a bit like a tower. At the base is the kernel. On top of that are all the basic tools. Next is all the software that you run on the computer. At the top of the tower is Debian -- carefully organizing and fitting everything so it all works together. ",
        "features": [
            "independant",
            "gnome",
            "live",
            "server",
            "easy set-up",
            "deb",
            "calligra",
            "goffice",
            "libreoffice",
            "systemd",
            "multilingual",
            "asian language support"
        ]
    },
    {
        "name": "Dragora GNU/Linux-Libre",
        "discription": "Dragora GNU/Linux-Libre is a distribution created from scratch with the intention of providing a stable, multi-platform and multi-purpose operating system. It is built upon 100% free software. It has a very simple packaging system that allows installing, removing, upgrading and creating packages. Dragora can be an ideal distribution for those who wish to learn how a distribution works on the inside.",
        "features": [
            "independant",
            "xfce",
            "free",
            "tlz"
        ]
    },
    {
        "name": "Exherbo",
        "discription": "Exherbo is a source-based Linux distribution inspired by the flexibility found in Gentoo Linux (among others). Designed primarily for developers and advanced users who are expected to take an active role in the development of the distribution, Exherbo offers a decentralised development model, original code, and a fast and flexible package manager called Paludis.",
        "features": [
            "independant",
            "server",
            "source based",
            "src",
            "goffice",
            "koffice",
            "openoffice"
        ]
    },
    {
        "name": "Fedora",
        "discription": "Fedora (formerly Fedora Core) is a Linux distribution developed by the community-supported Fedora Project and owned by Red Hat. Fedora contains software distributed under a free and open-source license and aims to be on the leading edge of such technologies. Fedora has a reputation for focusing on innovation, integrating new technologies early on and working closely with upstream Linux communities. The default desktop in Fedora is the GNOME desktop environment and the default interface is the GNOME Shell. Other desktop environments, including KDE, Xfce, LXDE, MATE and Cinnamon, are available. Fedora Project also distributes custom variations of Fedora called Fedora spins. These are built with specific sets of software packages, offering alternative desktop environments or targeting specific interests such as gaming, security, design, scientific computing and robotics.",
        "features": [
            "independant",
            "gnome",
            "live",
            "server",
            "easy set-up",
            "rpm",
            "calligra",
            "goffice",
            "libreoffice",
            "systemd",
            "multilingual",
            "asian language support"
        ]
    },
    {
        "name": "Gentoo Linux",
        "discription": "Gentoo Linux is a versatile and fast, completely free Linux distribution geared towards developers and network professionals. Unlike other distros, Gentoo Linux has an advanced package management system called Portage. Portage is a true ports system in the tradition of BSD ports, but is Python-based and sports a number of advanced features including dependencies, fine-grained package management, 'fake' (OpenBSD-style) installs, safe unmerging, system profiles, virtual packages, config file management, and more.",
        "features": [
            "independant",
            "kde plasma",
            "server",
            "source based",
            "src",
            "calligra",
            "goffice",
            "libreoffice",
            "openrc",
            "multilingual",
            "asian language support"
        ]
    },
    {
        "name": "gNewSense",
        "discription": "A product sponsored by the Free Software Foundation, gNewSense is a Debian-based Linux distribution released without any proprietary and non-free components, and several enhancements. Notably, all proprietary firmware, restricted modules and Debian logos are removed. The goal of the project is to produce a totally free ('libre') Linux distribution.",
        "features": [
            "debian",
            "gnome",
            "free",
            "live",
            "easy set-up",
            "deb",
            "libreoffice",
            "sysv",
            "multilingual"
        ]
    },
    {
        "name": "Kubuntu",
        "discription": "Kubuntu is an operating system built by a worldwide community of developers, testers, supporters and translators.\n\nKubuntu is a free, complete, and open-source alternative to Microsoft Windows and Mac OS X which contains everything you need to work, play, or share. Check out the Feature Tour if you would like to learn more!\n\nKubuntu unites Ubuntu with KDE and the fabulous Plasma desktop, bringing you a full set of applications. The installation includes productivity, office, email, graphics, photography, and music applications ready to use at startup.\n\nFirefox, Kmail, LibreOffice, Gwenview are just a few installed and ready to use, with thousands more, available in just a click, from the Discover software centre.\n\nBuilt using the Qt toolkit, Kubuntu is fast, slick and beautiful. Kubuntu is mobile-ready, enabling easy integration between your PC desktop and phone or tablet. Simply use the Google Play store to install KDE Connect on your Android device and you can integrate your device with your desktop.",
        "features": [
            "debian",
            "ubuntu",
            "kde plasma",
            "begginer friendly",
            "live",
            "server",
            "easy set-up",
            "deb",
            "libreoffice",
            "systemd",
            "multilingual",
            "asian language support"
        ]
    },
    {
        "name": "Linux Mint",
        "discription": "Linux Mint is an Ubuntu-based distribution whose goal is to provide a classic desktop experience with many convenient, custom tools and optional out-of-the-box multimedia support. It also adds a custom desktop and menus, several unique configuration tools, and a web-based package installation interface. Linux Mint is compatible with Ubuntu software repositories",
        "features": [
            "debian",
            "ubuntu",
            "cinnamon",
            "mate",
            "xfce",
            "begginer friendly",
            "live",
            "easy set-up",
            "deb",
            "libreoffice",
            "systemd",
            "multilingual"
        ]
    },
    {
        "name": "LinuxConsole",
        "discription": "LinuxConsole is an independently developed Linux live CD with different editions designed for desktops, servers, gaming consoles, and old computers. Its primary characteristics are easy installation, extensive choice of software in the form of modules, and excellent hardware detection. ",
        "features": [
            "independant",
            "mate",
            "live",
            "libreoffice"
        ]
    },
    {
        "name": "Lubuntu",
        "discription": "Lubuntu is a fast and lightweight operating system with a clean and easy-to-use user interface. It is a Linux system, that uses the minimal desktop LXDE/LXQT, and a selection of light applications. Because of this, Lubuntu has very low hardware requirements. It includes essential applications and services for daily use, including office suite, PDF reader, image editor and multimedia players. A distribution available for both 32-bit and 64-bit computers, Lubuntu is intended to be user-friendly, lightweight and energy efficient. ",
        "features": [
            "debian",
            "ubuntu",
            "lxqt",
            "live",
            "easy set-up",
            "deb",
            "libreoffice",
            "systemd",
            "multilingual"
        ]
    },
    {
        "name": "NixOS",
        "discription": "NixOS is an independently developed GNU/Linux distribution that aims to improve the state of the art in system configuration management. In NixOS, the entire operating system, including the kernel, applications, system packages and configuration files, are built by the Nix package manager. Nix stores all packages in isolation from each other; as a result there are no /bin, /sbin, /lib or /usr directories and all packages are kept in /nix/store instead. Other innovative features of NixOS include reliable upgrades, rollbacks, reproducible system configurations, source-based model with binaries, and multi-user package management. Although NixOS started as a research project, it is now a functional and usable operating system that includes hardware detection, KDE as the default desktop, and systemd for managing system services. ",
        "features": [
            "independant",
            "gnome",
            "kde plasma",
            "education",
            "live",
            "server",
            "easy set-up",
            "nix",
            "systemd"
        ]
    },
    {
        "name": "NuTyX",
        "discription": "NuTyX is a French Linux distribution (with multi-language support) built from Linux From Scratch and Beyond Linux From Scratch, with a custom package manager called 'cards'. The package manager can install individual binary packages, a group of related binary packages (e.g. desktop packages, such as KDE or Xfce), and compile source packages from 'ports'. The distribution is designed for intermediate and advanced Linux users. ",
        "features": [
            "linux from scratch",
            "cards",
            "goffice",
            "libreoffice",
            "runit",
            "systemd",
            "sysv",
            "multilingual",
            "asian language support"
        ]
    },
    {
        "name": "openmamba GNU/Linux",
        "discription": "openmamba GNU/Linux is a distribution for personal computers (Intel i686-compatible) that can be used on notebooks, desktops and servers. It works as an installable live CD, offering out-of-the box support for proprietary graphics drivers and wireless network cards, a variety of media codecs and 3D desktop with KDE. The distribution, which has roots in the discontinued QiLinux project, uses APT for RPM and Synaptic as its package management tools. ",
        "features": [
            "independant",
            "kde plasma",
            "live",
            "raspberry pi",
            "server",
            "easy set-up",
            "rpm",
            "libreoffice",
            "systemd",
            "multilingual"
        ]
    },
    {
        "name": "OpenSUSE",
        "discription": "The openSUSE project is a community program sponsored by SUSE Linux and other companies. Promoting the use of Linux everywhere, this program provides free, easy access to openSUSE, a complete Linux distribution. The openSUSE project has three main goals: make openSUSE the easiest Linux for anyone to obtain and the most widely used Linux distribution; leverage open source collaboration to make openSUSE the world's most usable Linux distribution and desktop environment for new and experienced Linux users; dramatically simplify and open the development and packaging processes to make openSUSE the platform of choice for Linux developers and software vendors.",
        "features": [
            "independant",
            "gnome",
            "kde plasma",
            "xfce",
            "live",
            "raspberry pi",
            "server",
            "easy set-up",
            "rpm",
            "calligra",
            "goffice",
            "libreoffice",
            "systemd",
            "multilingual",
            "asian language support"
        ]
    },
    {
        "name": "Parabola GNU/Linux",
        "discription": "Parabola GNU/Linux-libre is an unofficial 'libre' variant of Arch Linux. It aims to provide a fully free (as in freedom) distribution based on the packages of the Arch Linux project, with packages optimised for i686 and x86_64 processors. The goal is to give the users complete control over their systems with 100% 'libre' software. Parabola GNU/Linux-libre is listed by the Free Software Foundation (FSF) as a fully free software distribution. Besides a standard installation CD image, the project also provides a live/rescue DVD image with MATE as the default desktop environment.",
        "features": [
            "arch",
            "lxde",
            "free",
            "server",
            "pacman",
            "goffice",
            "openrc",
            "multilingual"
        ]
    },
    {
        "name": "PCLinuxOS",
        "discription": "PCLinuxOS is a user-friendly Linux distribution with out-of-the-box support for many popular graphics and sound cards, as well as other peripheral devices. The bootable live DVD provides an easy-to-use graphical installer and the distribution sports a wide range of popular applications for the typical desktop user, including browser plugins and full multimedia playback. The intuitive system configuration tools include Synaptic for package management, Addlocale to add support to many languages and Mylivecd to create a customised live CD.",
        "features": [
            "independant",
            "kde plasma",
            "begginer friendly",
            "live",
            "easy set-up",
            "rpm",
            "calligra",
            "goffice",
            "libreoffice",
            "sysv"
        ]
    },
    {
        "name": "Peppermint OS",
        "discription": "Peppermint OS is a Lubuntu-based Linux distribution that aims to be lightning fast and easy on system resources. By employing its Site Specific Browser, Peppermint integrates seamlessly with cloud and web-based applications. The distribution's other features include automatic updates, easy step-by-step installation, sleek and user-friendly interface, and increased mobility by integrating directly with cloud-based applications. The distribution employs a hybrid LXDE/Xfce desktop environment, mixing LXDE's lxsession with Xfce's panel and application menu.",
        "features": [
            "debian",
            "lubuntu",
            "lxde",
            "live",
            "easy set-up",
            "deb",
            "systemd",
            "multilingual"
        ]
    },
    {
        "name": "PinguyOS",
        "discription": "PinguyOS is a Linux distribution that is built on the Ubuntu framework. PinguyOS was created by Antoni Norman and Antoni is still the lead developer of the project today. The ethos of PinguyOS is very simple, to look good, work well and most importantly to be simple to use. PinguyOS is very much designed for people who are new to the Linux world, many people coming from both a Windows or a Mac background will find plenty of familiar features along with some new ones that aren’t available in either Windows or Mac.",
        "features": [
            "debian",
            "ubuntu",
            "gnome",
            "begginer friendly",
            "easy set-up",
            "deb",
            "libreoffice",
            "systemd",
            "multilingual"
        ]
    },
    {
        "name": "Plop Linux",
        "discription": "Plop Linux is a small distribution that can boot from CD, DVD, USB flash drive (UFD), USB hard disk or from network with PXE. It is designed to rescue data from a damaged system, backup and restore operating systems, automate tasks and more.",
        "features": [
            "independant",
            "fluxbox",
            "mate",
            "xfce",
            "data rescue",
            "live",
            "raspberry pi",
            "sysv"
        ]
    },
    {
        "name": "Puppy Linux",
        "discription": "Puppy Linux is yet another Linux distribution. What's different here is that Puppy is extraordinarily small, yet quite full-featured. Puppy boots into a ramdisk and, unlike live CD distributions that have to keep pulling stuff off the CD, it loads into RAM. This means that all applications start in the blink of an eye and respond to user input instantly. Puppy Linux has the ability to boot off a flash card or any USB memory device, CDROM, Zip disk or LS/120/240 Superdisk, floppy disks, internal hard drive. It can even use a multisession formatted CD-RW/DVD-RW to save everything back to the CD/DVD with no hard drive required at all. ",
        "features": [
            "independant",
            "jwm",
            "from ram",
            "live",
            "netbooks",
            "easy set-up",
            "pet",
            "goffice",
            "sysv"
        ]
    },
    {
        "name": "Qubes OS",
        "discription": "Qubes OS is a security-oriented, Fedora-based desktop Linux distribution whose main concept is 'security by isolation' by using domains implemented as lightweight Xen virtual machines. It attempts to combine two contradictory goals: how to make the isolation between domains as strong as possible, mainly due to clever architecture that minimises the amount of trusted code, and how to make this isolation as seamless and easy as possible. ", 
        "features": [
            "fedora",
            "xfce",
            "security",
            "easy set-up",
            "rpm",
            "systemd"
        ]
    },
    {
        "name": "Red Hat Enterprise Linux",
        "discription": "Red Hat Enterprise Linux (RHEL) is a Linux distribution developed by Red Hat and targeted toward the commercial market. Red Hat Enterprise Linux is released in server editions for x86, x86_64, Itanium, PowerPC and IBM System z architectures, and desktop editions for x86 and x86_64 processors. All of Red Hat's official support and training and the Red Hat Certification Program centres around the Red Hat Enterprise Linux platform. Red Hat uses strict trademark rules to restrict free re-distribution of its officially supported versions of Red Hat Enterprise Linux, but still freely provides its source code. Third-party derivatives can be built and redistributed by stripping away non-free components.",
        "features": [
            "fedora",
            "gnome",
            "server",
            "easy set-up",
            "flatpak",
            "rpm",
            "libreoffice",
            "systemd",
            "multilingual",
            "asian language support"
        ]  
    },
    {
        "name": "Sabayon",
        "discription": "Sabayon is a Funtoo-based (prior to 2020 a Gentoo-based) distribution which follows the works-out-of-the-box philosophy, aiming to give the user a wide number of applications that are ready for use and a self-configured operating system. Sabayon offers the user an easy-to-use workspace with a captivating look, good hardware detection and a large number of up-to-date software packages installed by default, with additional software available from a repository. Sabayon is available in several flavors featuring respectively the KDE, GNOME and Xfce desktop environments. ",
        "features": [
            "gentoo",
            "gnome",
            "kde plasma",
            "lxqt",
            "mate",
            "xfce",
            "begginer friendly",
            "live",
            "raspberry pi",
            "easy set-up",
            "entropy",
            "libreoffice",
            "systemd"
        ]
    },
    {
        "name": "Scientific Linux",
        "discription": "Scientific Linux is a recompiled Red Hat Enterprise Linux, co-developed by Fermi National Accelerator Laboratory and the European Organization for Nuclear Research (CERN). Although it aims to be fully compatible with Red Hat Enterprise Linux, it also provides additional packages not found in the upstream product; the most notable among these are various file systems, including Cluster Suite and Global File System (GFS), FUSE, OpenAFS, Squashfs and Unionfs, wireless networking support with Intel wireless firmware, MadWiFi and NDISwrapper, Sun Java and Java Development Kit (JDK), the lightweight IceWM window manager, R - a language and environment for statistical computing, and the Alpine email client.",
        "features": [
            "red hat",
            "gnome",
            "live",
            "scientific",
            "server",
            "easy set-up",
            "rpm",
            "libreoffice",
            "systemd",
            "multilingual",
            "asian language support"
        ]
    },
    {
        "name": "Slackware Linux",
        "discription": "The Official Release of Slackware Linux by Patrick Volkerding is an advanced Linux operating system, designed with the twin goals of ease of use and stability as top priorities. Including the latest popular software while retaining a sense of tradition, providing simplicity and ease of use alongside flexibility and power, Slackware brings the best of all worlds to the table. Originally developed by Linus Torvalds in 1991, the UNIX-like Linux operating system now benefits from the contributions of millions of users and developers around the world. Slackware Linux provides new and experienced users alike with a fully-featured system, equipped to serve in any capacity from desktop workstation to machine-room server. Web, ftp, and email servers are ready to go out of the box, as are a wide selection of popular desktop environments. A full range of development tools, editors, and current libraries is included for users who wish to develop or compile additional software. ",
        "features": [
            "independant",
            "kde plasma",
            "server",
            "txz",
            "calligra",
            "sysv"
        ]
    },
    {
        "name": "SliTaz GNU/Linux",
        "discription": "SliTaz GNU/Linux is a mini distribution and live CD designed to run speedily on hardware with 256 MB of RAM. SliTaz uses BusyBox, a recent Linux kernel and GNU software. It boots with Syslinux and provides more than 200 Linux commands, the lighttpd web server, SQLite database, rescue tools, IRC client, SSH client and server powered by Dropbear, X window system, JWM (Joe's Window Manager), gFTP, Geany IDE, Mozilla Firefox, AlsaPlayer, GParted, a sound file editor and more. The SliTaz ISO image fits on a less than 30 MB media and takes just 80 MB of hard disk space",
        "features": [
            "independant",
            "lxde",
            "from ram",
            "live",
            "raspberry pi",
            "tazpkg",
            "multilingual"
        ]
    },
    {
        "name": "Source Mage",
        "discription": "Sourcemage is a source-based GNU/Linux distribution based on a Sorcery metaphor of 'casting' and 'dispelling' programs, which we refer to as 'spells'. ",
        "features": [
            "independant",
            "source based",
            "src",
            "calligra",
            "goffice",
            "libreoffice",
            "multilingual"
        ]
    },
    {
        "name": "SUSE Linux Enterprise",
        "discription": "SUSE Linux Enterprise is an interoperable platform for mission-critical computing.  SUSE Linux Enterprise Desktop is an enterprise-quality Linux desktop that's ready for routine business use.  It provides interoperability with existing systems and many office applications.  It also delivers flexibility for desktop and notebook clients, thin-client devices, and high-end technical workstations.  SUSE Linux Enterprise Server is designed to handle mission-critical workloads. It is an open, scalable, solution that comes with integrated Xen-based virtualization, application security, and systems management across a range of hardware architectures.  SUSE Linux Enterprise Server provides interoperability with Windows and other platforms, and it provides a secure foundation for a broad range of edge, departmental and data center needs.",
        "features": [
            "opensuse",
            "gnome",
            "raspberry pi",
            "server",
            "easy set-up",
            "rpm",
            "libreoffice",
            "systemd",
            "multilingual",
            "asian language support"
        ]
    },
    {
        "name": "Tiny Core Linux",
        "discription": "Tiny Core Linux is a 12 MB graphical Linux desktop. It is based on a recent Linux kernel, BusyBox, Tiny X, Fltk, and Flwm. The core runs entirely in memory and boots very quickly. The user has complete control over which applications and/or additional hardware to have supported, be it for a desktop, a nettop, an appliance or server; selectable from the project's online repository. ",
        "features": [
            "independant",
            "flwm",
            "from ram",
            "live",
            "raspberry pi",
            "tce",
            "busybox"
        ]
    },
    {
        "name": "Trisquel",
        "discription": "Trisquel is a computer operating system, a Linux distribution, derived from another distribution, Ubuntu. The project aims for a fully free software system without proprietary software or firmware and uses a version of Ubuntu's modified kernel, with the non-free code removed. Trisquel relies on user donations.",
        "features": [
            "debian",
            "ubuntu",
            "mate",
            "education",
            "free",
            "live",
            "easy set-up",
            "deb",
            "libreoffice",
            "systemd",
            "multilingual"
        ]
    },
    {
        "name": "Ubuntu",
        "discription": "Ubuntu is a complete desktop Linux operating system, freely available with both community and professional support. The Ubuntu community is built on the ideas enshrined in the Ubuntu Manifesto: that software should be available free of charge, that software tools should be usable by people in their local language and despite any disabilities, and that people should have the freedom to customise and alter their software in whatever way they see fit. 'Ubuntu' is an ancient African word, meaning 'humanity to others'. The Ubuntu distribution brings the spirit of Ubuntu to the software world. ",
        "features": [
            "debian",
            "gnome",
            "begginer friendly",
            "live",
            "server",
            "easy set-up",
            "deb",
            "libreoffice",
            "systemd",
            "multilingual",
            "asian language support"
        ]
    },
    {
        "name": "VectorLinux",
        "discription": "Speed, performance, stability -- these are attributes that set VectorLinux apart in the crowded field of Linux distributions. The creators of VectorLinux had a single credo: keep it simple, keep it small and let the end user decide what their operating system is going to be. What has evolved from this concept is perhaps the best little Linux operating system available anywhere. For the casual computer user you have a lightning fast desktop with graphical programs to handle your daily activities from web surfing, sending and receiving email, chatting on ICQ or IRC to running an ftp server. Power users will be pleased because all the tools are there to compile their own programs, use the system as a server or perhaps the gateway for their home or office computer network. Administrators will be equally as pleased because the small size and memory requirements of the operating system can be deployed on older machines maybe long forgotten. ",
        "features": [
            "slackware",
            "xfce",
            "txz",
            "goffice",
            "sysv"
        ]
    },
    {
        "name": "Void",
        "discription": "Void is an independently-developed, general-purpose operating system based on the monolithic Linux kernel. It features a hybrid binary/source package management system which allows users to quickly install, update and remove software, or to build software directly from sources with the help of the XBPS source packages collection. Other features of the distribution include support for Raspberry Pi single-board computers (both armv6 and armv7), rolling-release development model with daily updates, integration of OpenBSD's LibreSSL software, and native init system called 'runit'.",
        "features": [
            "independant",
            "cinnamon",
            "enlightenment",
            "lxde",
            "lxqt",
            "mate",
            "xfce",
            "live",
            "raspberry pi",
            "xbps",
            "runit"
        ]
    },
    {
        "name": "Xubuntu",
        "discription": "Xubuntu is a community developed operating system that combines elegance and ease of use.\n\nXubuntu is an elegant and easy to use operating system. Xubuntu comes with Xfce, which is a stable, light and configurable desktop environment.\n\nXubuntu is perfect for those who want the most out of their desktops, laptops and netbooks with a modern look and enough features for efficient, daily usage. It works well on older hardware too.",
        "features": [
            "debian",
            "ubuntu",
            "xfce",
            "begginer friendly",
            "easy set-up",
            "deb",
            "libreoffice",
            "systemd"
        ]
    },
    {
        "name": "Zenwalk",
        "discription": "Zenwalk is a 64 bits 'pure' Slackware system with added post-install configurations, optimizations and out of the box tweaks, with a ready to use polished desktop environment, with added graphical system tools, added office and multimedia applications, and striped to keep just 'one application' per task!",
        "features": [
            "slackware",
            "xfce",
            "live",
            "txz",
            "openoffice",
            "sysv"
        ]
    },
    {
        "name": "Zorin OS",
        "discription": "Zorin OS is the alternative to Windows and macOS. Zorin OS is an Ubuntu-based Linux distribution designed especially for newcomers to Linux. It has a Windows-like graphical user interface and many programs similar to those found in Windows. Zorin OS also comes with an application that lets users run many Windows programs. The distribution's ultimate goal is to provide a Linux alternative to Windows and let Windows users enjoy all the features of Linux without complications. ",
        "features": [
            "debian",
            "ubuntu",
            "gnome",
            "xfce",
            "begginer friendly",
            "live",
            "easy set-up",
            "deb",
            "flatpak",
            "snap",
            "libreoffice",
            "systemd",
            "multilingual"
        ]
    },
    {
        "name": "Please Wait..."
    }
]

export default linuxDistros;